/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { API } from 'aws-amplify';

import { allJobBidEstimation, jobBidSummary } from '../../../graphql/queries';

import { DeleteJobBidInput } from '../../../API';
import { deleteJobBids } from '../../../graphql/mutations';
import { AuthHeader, AWSAuthMode } from '../../../Shared/Constants/App';
import { getWebInfo, signedFetch } from '../../../Shared/Utilities/utils';
import { IGraphQLResponse } from '../../../Shared/Models';
import { AuthenticationService } from '../../../Shared/Services/AuthenticationService';
import awsConfig from '../../../Configuration/environment-config';

export default class VendorApiService {
  static async allServicesLinkedToBid(jobId: string, bidId: string) {
    try {
      const authHeaders: AuthHeader = await AuthenticationService.getAuthHeaders();
      const response: IGraphQLResponse = await API.graphql(
        {
          query: allJobBidEstimation,
          variables: { bidId, jobId },
          authMode: AWSAuthMode.COGNITO,
        },
        { ...getWebInfo(), ...authHeaders }
      );
      return { data: response.data?.allJobBidEstimation ?? [], errors: [] };
    } catch (e: any) {
      return { data: null, errors: e.errors };
    }
  }

  static async getBidSummary(bidId: string) {
    try {
      const authHeaders: AuthHeader = await AuthenticationService.getAuthHeaders();
      const response: IGraphQLResponse = await API.graphql(
        {
          query: jobBidSummary,
          variables: { bidId },
          authMode: AWSAuthMode.COGNITO,
        },
        { ...getWebInfo(), ...authHeaders }
      );
      return { data: response.data?.jobBidSummary ?? [], errors: [] };
    } catch (e: any) {
      return { data: null, errors: e.errors };
    }
  }

  static async deleteJobBids(deleteJobBidsInput: DeleteJobBidInput) {
    try {
      const authHeaders: AuthHeader = await AuthenticationService.getAuthHeaders();
      const deleteJobBidsResponse: IGraphQLResponse = await API.graphql(
        {
          query: deleteJobBids,
          variables: { deleteJobBidsInput },
          authMode: AWSAuthMode.COGNITO,
        },
        { ...getWebInfo(), ...authHeaders }
      );
      return { data: deleteJobBidsResponse.data?.deleteJobBids ?? {}, errors: [] };
    } catch (e: any) {
      return { data: {}, errors: e?.errors ?? [] };
    }
  }

  static async getJobBidSummary(bidId: string) {
    try {
      const endpointConfig = awsConfig.aws_cloud_logic_custom.find((api) => api.name === 'jobBidSummary');

      if (!endpointConfig?.endpoint) {
        console.error('Endpoint configuration not found');
        return { success: false, errors: [{ message: 'Endpoint not found' }] };
      }
      const endpointUrl = `${endpointConfig.endpoint}/${bidId}/summary`;
      const result = await signedFetch({
        method: 'GET',
        url: endpointUrl,
      });
      return {
        data: result?.data,
        errors: result?.errors || [],
      };
    } catch (error: any) {
      console.error('failed to fetch bidSummary', error);
    }
  }
}
